import { render, staticRenderFns } from "./comp-nota-alunos.vue?vue&type=template&id=70c47f4d&scoped=true"
import script from "./comp-nota-alunos.vue?vue&type=script&lang=js"
export * from "./comp-nota-alunos.vue?vue&type=script&lang=js"
import style0 from "./comp-nota-alunos.vue?vue&type=style&index=0&id=70c47f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c47f4d",
  null
  
)

export default component.exports